// import { createViewModel, ProcessIntegrationView } from '@qpr/process-integration';
import { createViewModel, ProcessIntegrationView } from '@qpr/process-integration';
import React, { useContext, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import { isMongoId } from '../utils/url-utils';

const ProcessIntegrationPage = () => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(true);
    appBarContext.setPeriodSelector(false);
  });

  const { search } = useLocation();
  const { e2eProcessId } = useParams<{ e2eProcessId: string }>();
  const queryString = new URLSearchParams(search);
  const viewDefinitionId = queryString.get('viewdefinitionid');
  const viewModel = createViewModel();

  return (
    <>
      <ProcessIntegrationView
        viewModel={viewModel}
        e2eProcessId={e2eProcessId}
        viewDefinitionId={viewDefinitionId && isMongoId(viewDefinitionId) ? viewDefinitionId : ''}
      />
    </>
  );
};

export default ProcessIntegrationPage;
